export default "__VITE_ASSET__D9ih$S1r__"